import { convertTextWithCitations } from 'modules/shared/libs/chat/utils/sources.utils';

import type {
  ChatUIMessage,
  CitationSource,
} from 'modules/shared/libs/chat/types';

export type ResearchApiMessage = {
  id: string;
  thread_id: string;
  message: {
    id: string;
    role: 'user' | 'assistant';
    content: string;
    name: string | null;
  };
  citation_sources: CitationSource[];
  followups: unknown[];
};

export function convertResearchApiMessagesToUIMessages(
  messages: ResearchApiMessage[],
): ChatUIMessage[] {
  return messages.map((msg) => {
    const baseMessage = {
      id: msg.id,
      createdAt: new Date(),
    };

    if (msg.message.role === 'user') {
      return {
        ...baseMessage,
        role: 'user' as const,
        parts: [
          { type: 'text' as const, text: msg.message.content, state: 'done' },
        ],
      };
    }

    const parts: ChatUIMessage['parts'] = [
      {
        type: 'text' as const,
        text: convertTextWithCitations(msg.message.content),
        state: 'done',
      },
    ];

    if (msg.citation_sources && msg.citation_sources.length > 0) {
      parts.push({
        type: 'data-citation_sources',
        data: msg.citation_sources,
      });
    }

    return {
      ...baseMessage,
      role: 'assistant' as const,
      parts,
    };
  });
}
